import App from './PurpleRibbonPage.vue'
import Router from 'vue-router'
import DSRouter from '@/services/DSRouter'
import { getTabs, getUserState } from '@/services/HttpSvc'

export default function mountApp(Vue, targetId) {
  if (document.getElementById(targetId)) {
    const location = window.location + ''
    if(location.split('/')[4]) {
      setTimeout(function() {window.scrollTo({
        top: document.getElementById(targetId).offsetTop,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      })}, 1500)
    }
    //console.debug(`mounting ${targetId}`)
    mountPurpleRibbonApp(Vue, targetId)
  }
}

/**
 * Mounts the main Purple Ribbon Awards landing page app
 * Requires a server request for tabs content, manged by
 * the DS Admin CMS.
 * @return {void}
 */
async function mountPurpleRibbonApp(Vue, targetId) {
  import(/* webpackChunkName: "smoothscroll-polyfill" */ 'smoothscroll-polyfill/dist/smoothscroll').then(ss => ss.polyfill());

  DSRouter.setRouterData(await getTabs())
  const router = new Router(DSRouter.getVueRouterConfig())
  router.beforeEach(handleAuthRedirect)

  Vue.use(Router)

  new Vue({
    router,
    render: h => h(App),
  }).$mount(`#${targetId}`)

  document.querySelectorAll('[data-router-link]').forEach(
    link => link.addEventListener('click', routeToVueRoute))

  /**
   * Allows a user to route to a vue-router route
   * from outside of vue-render markup
   * without forcing the page to reload.
   * @param  {Event} e A native click event
   * @return {void}
   */
  function routeToVueRoute(e) {
    e.preventDefault()
    if (router.options.base + e.target.dataset.routerLink !== window.location.pathname) {
      router.push(e.target.dataset.routerLink)
    } else {
      document.getElementById(targetId).scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      })
    }
  }
}

async function handleAuthRedirect(to, from, next) {
  if (to.meta.requiresAuth || to.meta.authRedirect) {
    next(await determineNextPage(to))
  } else {
    next()
  }
}

async function determineNextPage({ name, meta }) {
  const userState = await getUserState()

  if (!userState.logged_in) {
    return {
      path: meta.requiresAuth,
    }
  }

  else {
    return {
      path: meta.authRedirect,
    }
  }
}
